import PropTypes from 'prop-types';
import {Link as RouterLink} from 'react-router-dom';
import CarouselBlock from './carouselBlock';
import RecipeBlock from './recipeBlock';
import RecipeInformation from './recipeInformation';
import {Container, Image, Subtitle, Description, MainTitleDark, BackLink, Ingredients} from './styles';
import {Hr, SmallTitle, HrLine, Link, Submit as ButtonMore} from 'ui';

const BaseRecipe = ({history, data}) => {
  // const {id} = match.params;
  if (!data) return null;
  return (
    <Container>
      <Image src={data.acf.recette_image_principale.url} />
      <BackLink to="/recipes" />
      <Hr />
      <SmallTitle>
        les recettes {data.acf.recette_citation_auteur && `de ${data.acf.recette_citation_auteur}`}
      </SmallTitle>
      <MainTitleDark>{`${data.acf.recette_premiere_partie_titre} ${data.acf.recette_deuxieme_partie_titre}`}</MainTitleDark>
      <HrLine />
      <Subtitle>Conseils & Astuces</Subtitle>
      <Description>{data.acf.recette_citation_texte}</Description>
      <CarouselBlock carouselData={data.acf.recette_produits} />
      <Link as={RouterLink} to="/products">
        Voir tous nos produits
      </Link>
      <Subtitle>Ingrédients</Subtitle>
      <HrLine />

      <Ingredients
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: data.acf.recette_ingredients,
        }}
      />
      <RecipeBlock recipeSteps={data.acf.recette_corps} recipeImages={data.acf.recette_images} />
      <ButtonMore onClick={() => history.push(`/recipes`)} style={{marginBottom: 25}}>
        Voir toutes les recettes
      </ButtonMore>
      <RecipeInformation />
    </Container>
  );
};

BaseRecipe.propTypes = {
  // id: PropTypes.string,
  // match: PropTypes.object.isRequired,
  data: PropTypes.object,
  history: PropTypes.object.isRequired,
};

export default BaseRecipe;
